import { Heart, MessageCircle, Send, Bookmark, MoreHorizontal } from "lucide-react";

const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1618424599646-14f0a25990f1?w=600&h=600&fit=crop";

export const InstagramPreview = ({ content, media }) => {
  const displayMedia = media && media.length > 0 ? media[0] : null;

  return (
    <div className="preview-container bg-white rounded-lg overflow-hidden" data-testid="instagram-preview">
      {/* Header */}
      <div className="flex items-center gap-3 p-3 border-b border-gray-100">
        <div className="w-8 h-8 rounded-full p-[2px] bg-gradient-to-br from-[#f09433] via-[#dc2743] to-[#bc1888]">
          <div className="w-full h-full rounded-full bg-white p-[2px]">
            <img 
              src="https://images.unsplash.com/photo-1631387019069-2ff599943f9a?w=64&h=64&fit=crop&crop=face"
              alt="Profile"
              className="w-full h-full rounded-full object-cover"
            />
          </div>
        </div>
        <div className="flex-1">
          <p className="font-semibold text-[14px] text-[#262626]">mon_compte</p>
        </div>
        <button className="p-1">
          <MoreHorizontal className="w-5 h-5 text-[#262626]" />
        </button>
      </div>

      {/* Media */}
      <div className="relative bg-black">
        {displayMedia?.type === "video" ? (
          <video 
            src={displayMedia.url} 
            className="w-full aspect-square object-contain bg-black"
            controls
          />
        ) : (
          <img 
            src={displayMedia?.url || DEFAULT_IMAGE} 
            alt="Post media"
            className="w-full aspect-square object-cover"
          />
        )}
      </div>

      {/* Actions */}
      <div className="flex items-center justify-between p-3">
        <div className="flex items-center gap-4">
          <button className="hover:opacity-60 transition-opacity">
            <Heart className="w-6 h-6 text-[#262626]" />
          </button>
          <button className="hover:opacity-60 transition-opacity">
            <MessageCircle className="w-6 h-6 text-[#262626]" />
          </button>
          <button className="hover:opacity-60 transition-opacity">
            <Send className="w-6 h-6 text-[#262626]" />
          </button>
        </div>
        <button className="hover:opacity-60 transition-opacity">
          <Bookmark className="w-6 h-6 text-[#262626]" />
        </button>
      </div>

      {/* Likes */}
      <div className="px-3 pb-1">
        <p className="font-semibold text-[14px] text-[#262626]">1,234 J'aime</p>
      </div>

      {/* Caption */}
      <div className="px-3 pb-3">
        <p className="text-[14px] text-[#262626] leading-[18px]">
          <span className="font-semibold mr-1">mon_compte</span>
          <span className="whitespace-pre-wrap">
            {content || "Écrivez votre légende..."}
          </span>
        </p>
      </div>

      {/* Comments */}
      <div className="px-3 pb-2">
        <p className="text-[14px] text-[#8E8E8E]">Voir les 48 commentaires</p>
      </div>

      {/* Time */}
      <div className="px-3 pb-3">
        <p className="text-[10px] text-[#8E8E8E] uppercase tracking-wide">Il y a 2 heures</p>
      </div>
    </div>
  );
};

export default InstagramPreview;
